import { ProjectIcon } from '@cfs-fixings/shared'
import { ProjectResource } from '@/api/serverApi'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

type PropTypes = {
  projects?: ProjectResource[]
  footerElements?: React.ReactNode[]
  dropdown: ({ project }: {project: ProjectResource}) => JSX.Element
}

function ProjectListView ({ projects, footerElements, dropdown: DropDown }: PropTypes) {
  return (
    <ul className="w-full">
      {
        projects?.map((project, index) => (
          <Link
            key={project.id}
            to={`/projects/${project.id}`}
          >
            <li className="hover:bg-gray-50 transition-all px-2.5">
              <div
                className={classNames('flex flex-row border-b border-b-gray-100 gap-4', {
                  'border-b-0': index === projects.length - 1,
                })}
              >
                <div
                  className="flex flex-row items-center grow gap-[5px] py-2.5"
                >
                  <ProjectIcon className="h-[18px] w-[18px] shrink-0" />
                  <p className="text-sm font-medium leading-[16.8px]">{project.name}</p>
                </div>
                <p className="text-xs font-medium leading-[16.8px] text-gray-600 my-auto shrink-0">{`${project.designs_count} Design Files`}</p>
                <div className="flex items-center ml-4">
                  <DropDown project={project} />
                </div>
              </div>
            </li>
          </Link>
        ))
      }
      {
        ...(footerElements ?? [])
      }
    </ul>
  )
}

export default ProjectListView
